import React, { useState, useEffect } from "react";
import { Table, Button, message, Space, Popconfirm } from "antd";
import { DeleteOutlined, ReloadOutlined } from "@ant-design/icons";
import { apiClient } from "../../utils/apiClient";
import { popupEnquiryApi } from "../../config/api";
import "./PopupEnquiries.scss";

const PopupEnquiries = () => {
  const [enquiries, setEnquiries] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchEnquiries = async () => {
    setLoading(true);
    try {
      const response = await apiClient(popupEnquiryApi);
      const result = await response.json();
      if (response.ok) {
        setEnquiries(Array.isArray(result) ? result : (result.data || []));
      } else {
        throw new Error(result.message || "Failed to fetch enquiries");
      }
    } catch (error) {
      console.error("Error fetching enquiries:", error);
      message.error("Failed to load enquiries");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEnquiries();
  }, []);

  const handleDelete = async (id) => {
    try {
      const response = await apiClient(`${popupEnquiryApi}/${id}`, { method: 'DELETE' });
      if (!response.ok) {
        throw new Error("Failed to delete enquiry");
      }
      message.success("Enquiry deleted successfully");
      fetchEnquiries();
    } catch (error) {
      console.error("Error deleting enquiry:", error);
      message.error("Failed to delete enquiry");
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Mobile",
      dataIndex: "mobile",
      key: "mobile",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Subject",
      dataIndex: "subject",
      key: "subject",
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text) => new Date(text).toLocaleString(),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space size="middle">
          <Popconfirm
            title="Are you sure you want to delete this enquiry?"
            onConfirm={() => handleDelete(record._id)}
            okText="Yes"
            cancelText="No"
          >
            <Button danger icon={<DeleteOutlined />} size="small">
              Delete
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div className="popup-enquiries-container">
      <div className="header-actions">
        <h2>Popup Enquiries</h2>
        <Button
          type="primary"
          icon={<ReloadOutlined />}
          onClick={fetchEnquiries}
          loading={loading}
        >
          Refresh
        </Button>
      </div>
      <div className="table-container">
        <Table
          columns={columns}
          dataSource={enquiries}
          rowKey="_id"
          loading={loading}
          pagination={{ pageSize: 10 }}
        />
      </div>
    </div>
  );
};

export default PopupEnquiries;
